import React, { useState } from "react";

// Context
import { useAuth } from "../../../contexts/AuthContext";

// Hooks
import useSnackbarNotification from "../../../hooks/useSnackbarNotification";

const DeleteAccount = () => {
    const { session, user } = useAuth();
    const { showSuccess, showError } = useSnackbarNotification();

    const [isLoading, setIsLoading] = useState(false);

    const handleDeleteAccount = async () => {
        try {
            setIsLoading(true);

            localStorage.removeItem("sb-zloptqlrfovwujzgytlm-auth-token");

            const response = await fetch(
                "https://zloptqlrfovwujzgytlm.supabase.co/functions/v1/delete-user",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${session.access_token}`,
                    },
                    body: JSON.stringify({ user_id: user.id }),
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Failed to delete account");
            }
            showSuccess("Account deleted successfully");
            window.location.href = "/";
            setIsLoading(false);
        } catch (error) {
            showError(
                error.message || "Failed to delete account. Please try again."
            );
            setIsLoading(false);
        }
    };

    return (
        <div className="mb-9">
            <h2 className="font-bold text-xl mb-3">Delete Account</h2>
            <p className="text-gray-800 text-base mb-3">
                To cancel your Doctors Jobs account and delete all your career
                data just click the button below.
            </p>
            <button
                onClick={handleDeleteAccount}
                disabled={isLoading}
                className="px-8 py-2 rounded-full border border-red-700 bg-white text-red-700 font-medium text-base mt-3 hover:bg-red-50 transition-colors"
            >
                {isLoading ? "Deleting..." : "Delete My Account"}
            </button>
        </div>
    );
};

export default DeleteAccount;
